module.exports = __webpack_public_path__ + "img/c16ea5d11cdf9408fddc63ee10e67068.01da9340.png";